import type { CSSProperties } from 'react'

import { cn, hasMeaningfulHtml, sanitizeRichTextHtml } from '@/shared/lib'

export function HtmlContent({
  html,
  className,
  style,
  'data-testid': dataTestId,
}: {
  html: string | null | undefined
  className?: string
  style?: CSSProperties
  'data-testid'?: string
}) {
  if (!hasMeaningfulHtml(html)) {
    return null
  }

  const sanitized = sanitizeRichTextHtml(html)
  if (!sanitized) {
    return null
  }

  return (
    <div
      data-testid={dataTestId}
      className={cn('catalog-html-content', className)}
      style={style}
      dangerouslySetInnerHTML={{ __html: sanitized }}
    />
  )
}
